<div class="modal-header border-0 bg-light">
  <h5 class="modal-title fw-bold">
    <i class="fas fa-info-circle text-primary me-2"></i>
    {{item?.Platform === 'postscript_create' ? 'Postscript Details' : 'Sendlane Details'}}
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body p-4">
  <!-- Item Information Section -->
  <div class="section mb-4">
    <h6 class="section-title mb-3">
      <i class="fas fa-clipboard-list text-primary me-2"></i>
      Item Information
    </h6>
    <div class="info-grid">
      <div class="info-item">
        <label>ID</label>
        <div class="value">{{item?.id}}</div>
      </div>
      <div class="info-item">
        <label>Registration ID</label>
        <div class="value">{{item?.RegistrationId}}</div>
      </div>
      <div class="info-item">
        <label>Step ID</label>
        <div class="value">{{item?.StepId}}</div>
      </div>
      <div class="info-item">
        <label>Email</label>
        <div class="value">{{item?.Email}}</div>
      </div>
      <div class="info-item">
        <label>Platform</label>
        <div class="value">{{item?.Platform}}</div>
      </div>
      <div class="info-item">
        <label>Status</label>
        <div class="value">
          <span class="status-badge" [ngClass]="{
            'success': item?.IsCompleted === 1,
            'danger': item?.IsFailed === 1,
            'warning': !item?.IsCompleted && !item?.IsFailed
          }">{{item?.IsCompleted === 1 ? 'Completed' : (item?.IsFailed === 1 ? 'Failed' : 'Pending')}}</span>
        </div>
      </div>
      <div class="info-item">
        <label>Created Date</label>
        <div class="value">{{item?.CreatedDate | date:'MMM dd, yyyy HH:mm:ss a'}}</div>
      </div>
      <div class="info-item">
        <label>Updated Date</label>
        <div class="value">{{item?.UpdatedDate | date:'MMM dd, yyyy HH:mm:ss a'}}</div>
      </div>
    </div>
  </div>

  <!-- Payload Section -->
  <div class="section mb-4">
    <h6 class="section-title mb-3">
      <i class="fas fa-code text-primary me-2"></i>
      Payload
    </h6>
    <div class="code-container">
      <pre class="code-block"><code [innerHTML]="formatJSON(item?.Payload)"></code></pre>
    </div>
  </div>

  <!-- Response Section -->
  <div class="section">
    <h6 class="section-title mb-3">
      <i class="fas fa-reply text-primary me-2"></i>
      Response
    </h6>
    <div class="code-container">
      <pre class="code-block"><code [innerHTML]="formatJSON(item?.Response)"></code></pre>
    </div>
  </div>
</div>



<style>
.modal-header {
  padding: 1rem 1.5rem;
}

.modal-title {
  font-size: 1.25rem;
  color: #2c3e50;
}

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.modal-body::-webkit-scrollbar {
  display: none;
}

.section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  border: 1px solid #d3d3d3;
  padding: 1.5rem;
}

.section-title {
  color: #2c3e50;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.25rem;
}

.info-item {
  display: flex;
  flex-direction: column;
}

.info-item label {
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.info-item .value {
  font-size: 0.95rem;
  color: #2c3e50;
  font-weight: 500;
}

.status-badge {
  display: inline-block;
  padding: 0.35rem 0.75rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
}

.status-badge.success {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.status-badge.danger {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.status-badge.warning {
  background-color: rgba(255, 193, 7, 0.1);
  color: #856404;
}

.code-container {
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.code-block {
  margin: 0;
  padding: 1rem;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #2c3e50;
  max-height: 300px;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.code-block::-webkit-scrollbar {
  display: none;
}

/* JSON formatting styles */
.json-key {
  color: #e83e8c;
}

.json-string {
  color: #28a745;
}

.json-number {
  color: #fd7e14;
}

.json-boolean {
  color: #007bff;
}

.json-null {
  color: #6c757d;
}

.modal-footer {
  padding: 1rem 1.5rem;
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
  padding: 0.5rem 1.5rem;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}
</style> 